import { useClientStore } from '@/stores/system'
import { storeToRefs } from 'pinia'
import errorMessages from 'constants/errorMessages'

export const useSubscription = () => {
	const {
		subscriptions,
		subscriptionPerks,
	} = storeToRefs(useClientStore())

	function checkIfSubscribedTo(component: string) {
		const subscriptionItem = subscriptions.value
			?.flatMap((subscription) => [
				...subscription.subscriptionModules,
				...subscription.subscriptionMethods,
			])
			.find((element) => element.name === component)

		let allowed = false
		let reason = ''

		if (subscriptionItem) {
			allowed = true
		}

		return {
			// subscription,
			allowed,
			reason,
		}
	}

	return {
		subscriptions,
		subscriptionPerks,
		checkIfSubscribedTo,
	}
}
